import React from 'react';

function Footer() {
  return (
    <footer>
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
         {/* Bottom area */}
        <div className="md:flex md:items-center md:justify-between py-4 md:py-8 border-t border-gray-200">
          <div className="text-sm text-bold text-gray-600 mr-4 cursor-pointer">Made by <a className="text-blue-600 hover:underline"
            href="https://lahiri.netlify.app/">Sumit Lahiri, IIT Kanpur</a>. Adapted from <a className="text-blue-600 text-bold hover:underline"
                        href="https://github.com/cruip/tailwind-landing-page-template">Cruip Template</a> </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
